<template>
  <section class="bg_color">
    <h2>ルール</h2>

    <section class="inner p0">
      <div class="box_lst mt0 slide moter_lst pb0">
        <h4 class="ttl_lst">
          <div class="inner tac heading_icon">
            <span class="moter_icon">1.登録可能モーターについて</span>
          </div>
        </h4>
        <ul class="box_txt-list">
          <li>
            ・BOAT RACE蒲郡で使用される6モーターまでが登録可能となります。
          </li>
          <li>
            ・一度登録したモーターの変更はできません。<br />※各TURNで新たにモーター登録を行えます。
          </li>
          <li>
            ・１メールアドレス1アカウントでの参加のみとし、複数アカウントでのご参加はランキングや賞品受け取り対象外とさせていただきます。
          </li>
          <li>
            ・一度に6モーターを登録する必要はありません。<br />時期をおいて数モーターずつ選択することもできます。
          </li>
        </ul>
        <h4 class="ttl_lst">
          <div class="inner tac heading_icon icon_coin">
            <span class="moter_icon">2.ポイント加算について</span>
          </div>
        </h4>
        <ul class="box_txt-list">
          <li>
            ・BOATRACEOfficial発表のレース結果に基づきモグーを計算し、ポイント加算が行われます。
          </li>
          <li>
            ・モグーはMOG独自の賞金テーブルに基づき計算されます。
            <ul class="grade">
              <li>
                <span
                  class="moter_icon clickable-text"
                  @click="
                    openModal({
                      title: 'グレードレースの賞金テーブル',
                      message: 'GⅢ以上の賞金配分は以下の通りです。',
                      showTable: true,
                      tableData: {
                        headers: [
                          'レース種別',
                          '1着',
                          '2着',
                          '3着',
                          '4着',
                          '5着',
                          '6着',
                        ],
                        rows: [
                          {
                            grade: '一般戦',
                            prizes: [127000, 92000, 68000, 0, 0, 0],
                          },
                          {
                            grade: '予選',
                            prizes: [127000, 92000, 68000, 0, 0, 0],
                          },
                          {
                            grade: '予選特賞',
                            prizes: [155000, 117000, 85000, 0, 0, 0],
                          },
                          {
                            grade: '予選特選',
                            prizes: [161000, 123000, 94000, 0, 0, 0],
                          },
                          {
                            grade: '予選記者特選',
                            prizes: [
                              166000, 127000, 97000, 71000, 57000, 46000,
                            ],
                          },
                          {
                            grade: '一般記者特選',
                            prizes: [
                              166000, 127000, 97000, 71000, 57000, 46000,
                            ],
                          },
                          {
                            grade: 'ガマポ投票選抜',
                            prizes: [
                              166000, 127000, 97000, 71000, 57000, 46000,
                            ],
                          },
                          {
                            grade: '女満名人戦',
                            prizes: [
                              166000, 127000, 97000, 71000, 57000, 46000,
                            ],
                          },
                          {
                            grade: '選抜戦',
                            prizes: [
                              329000, 247000, 192000, 141000, 115000, 93000,
                            ],
                          },
                          {
                            grade: '特別選抜B戦',
                            prizes: [
                              329000, 247000, 192000, 141000, 115000, 93000,
                            ],
                          },
                          {
                            grade: '特別選抜A戦',
                            prizes: [
                              329000, 247000, 192000, 141000, 115000, 93000,
                            ],
                          },
                          {
                            grade: 'トトまる選抜戦',
                            prizes: [
                              329000, 247000, 192000, 141000, 115000, 93000,
                            ],
                          },
                          {
                            grade: '特別選抜戦',
                            prizes: [
                              329000, 247000, 192000, 141000, 115000, 93000,
                            ],
                          },
                          {
                            grade: '準優勝戦',
                            prizes: [
                              177000, 138000, 108000, 77000, 59000, 48000,
                            ],
                          },
                          {
                            grade: '優勝戦',
                            prizes: [
                              1250000, 850000, 670000, 540000, 500000, 460000,
                            ],
                          },
                          {
                            grade: '一般特賞',
                            prizes: [155000, 117000, 85000, 0, 0, 0],
                          },
                          {
                            grade: '一般特選',
                            prizes: [161000, 123000, 94000, 0, 0, 0],
                          },
                          {
                            grade: 'ドリーム戦',
                            prizes: [
                              177000, 138000, 108000, 77000, 59000, 48000,
                            ],
                          },
                          { grade: '準優進出戦', prizes: [0, 0, 0, 0, 0, 0] },
                        ],
                      },
                    })
                  "
                  >グレードレースの場合</span
                >
              </li>
              <li>
                <span
                  class="moter_icon clickable-text"
                  @click="
                    openModal({
                      title: '正月レース・GWレース・お盆レースの賞金テーブル',
                      message:
                        '正月レース・GWレース・お盆レースの賞金配分は以下の通りです。',
                      showTable: true,
                      tableData: {
                        headers: [
                          'レース種別',
                          '1着',
                          '2着',
                          '3着',
                          '4着',
                          '5着',
                          '6着',
                        ],
                        rows: [
                          {
                            grade: '一般戦',
                            prizes: [167000, 122000, 89000, 0, 0, 0],
                          },
                          {
                            grade: '予選',
                            prizes: [167000, 122000, 89000, 0, 0, 0],
                          },
                          {
                            grade: '予選特賞',
                            prizes: [168000, 123000, 90000, 0, 0, 0],
                          },
                          {
                            grade: '予選特選',
                            prizes: [169000, 124000, 91000, 0, 0, 0],
                          },
                          {
                            grade: '選抜戦',
                            prizes: [
                              382000, 273000, 215000, 159000, 135000, 112000,
                            ],
                          },
                          {
                            grade: '特別選抜B戦',
                            prizes: [
                              382000, 273000, 215000, 159000, 135000, 112000,
                            ],
                          },
                          {
                            grade: '特別選抜A戦',
                            prizes: [
                              382000, 273000, 215000, 159000, 135000, 112000,
                            ],
                          },
                          {
                            grade: 'トトまる選抜戦',
                            prizes: [
                              382000, 273000, 215000, 159000, 135000, 112000,
                            ],
                          },
                          {
                            grade: '特別選抜戦',
                            prizes: [
                              382000, 273000, 215000, 159000, 135000, 112000,
                            ],
                          },
                          {
                            grade: '準優勝戦',
                            prizes: [
                              296000, 204000, 134000, 102000, 81000, 69000,
                            ],
                          },
                          {
                            grade: '優勝戦',
                            prizes: [
                              1730000, 1220000, 870000, 710000, 650000, 630000,
                            ],
                          },
                          {
                            grade: '一般特賞',
                            prizes: [168000, 123000, 90000, 0, 0, 0],
                          },
                          {
                            grade: '一般特選',
                            prizes: [169000, 124000, 91000, 0, 0, 0],
                          },
                          {
                            grade: 'ドリーム戦',
                            prizes: [
                              296000, 204000, 134000, 102000, 81000, 69000,
                            ],
                          },
                        ],
                      },
                    })
                  "
                  >正月レース・GWレース・お盆レース</span
                >
              </li>
              <li>
                <span
                  class="moter_icon clickable-text"
                  @click="
                    openModal({
                      title: '一般戦の賞金テーブル',
                      message: '一般戦の賞金配分は以下の通りです。',
                      showTable: true,
                      tableData: {
                        headers: [
                          'レース種別',
                          '1着',
                          '2着',
                          '3着',
                          '4着',
                          '5着',
                          '6着',
                        ],
                        rows: [
                          {
                            grade: '一般戦',
                            prizes: [113000, 81000, 56000, 0, 0, 0],
                          },
                          {
                            grade: '予選',
                            prizes: [113000, 81000, 56000, 0, 0, 0],
                          },
                          {
                            grade: '予選特賞',
                            prizes: [127000, 94000, 69000, 0, 0, 0],
                          },
                          {
                            grade: '予選特選',
                            prizes: [148000, 110000, 77000, 0, 0, 0],
                          },
                          {
                            grade: '予選記者特選',
                            prizes: [
                              153000, 114000, 80000, 55000, 42000, 32000,
                            ],
                          },
                          {
                            grade: '一般記者特選',
                            prizes: [
                              153000, 114000, 80000, 55000, 42000, 32000,
                            ],
                          },
                          {
                            grade: 'ガマポ投票選抜',
                            prizes: [
                              153000, 114000, 80000, 55000, 42000, 32000,
                            ],
                          },
                          {
                            grade: '女流名人戦',
                            prizes: [
                              153000, 114000, 80000, 55000, 42000, 32000,
                            ],
                          },
                          {
                            grade: '選抜戦',
                            prizes: [
                              301000, 220000, 169000, 129000, 106000, 84000,
                            ],
                          },
                          {
                            grade: '準優勝戦',
                            prizes: [
                              168000, 130000, 97000, 64000, 51000, 41000,
                            ],
                          },
                          {
                            grade: '優勝戦',
                            prizes: [
                              1050000, 768000, 608000, 474000, 441000, 418000,
                            ],
                          },
                          {
                            grade: '一般特賞',
                            prizes: [127000, 94000, 69000, 0, 0, 0],
                          },
                          {
                            grade: '一般特選',
                            prizes: [148000, 110000, 77000, 0, 0, 0],
                          },
                          {
                            grade: 'ドリーム戦',
                            prizes: [
                              168000, 130000, 97000, 64000, 51000, 41000,
                            ],
                          },
                          {
                            grade: '準優進出戦',
                            prizes: [
                              153000, 114000, 80000, 55000, 42000, 32000,
                            ],
                          },
                        ],
                      },
                    })
                  "
                  >一般戦</span
                >
              </li>
            </ul>
          </li>
          <li>・2027年度に賞金テーブルが変更になる可能性がございます。</li>
          <li>・モーターを登録してからでないと、ポイント加算されません。</li>
          <li>
            ・その他イレギュラーな結果については、MOG運営事務局の判断により対応をする場合があります。
          </li>
        </ul>
        <h4 class="ttl_lst">
          <div class="inner tac heading_icon icon_cal">
            <span class="moter_icon">3.集計対象レース・期間</span>
          </div>
        </h4>
        <ul class="box_txt-list">
          <li>
            ■ 1st TURN<br />
            ・開催期間：2026年9月4日（金）～2027年1月31日（日）<br />
            ・モーター登録開始：2026年8月11日（火）
          </li>
          <li>
            ■ 2nd TURN<br />
            ・開催期間：2027年2月24日(水)～2027年のモーター入替まで<br />
            ・モーター登録開始：2026年2月3日(水)
          </li>
          <li class="no-indent">
            ・各TURNとも、開催期間中のボートレース蒲郡で行われるすべてのレースが対象です。<br />
            ※SG,GⅠ,GⅡも対象ですが、獲得モグーはグレードレース共通の賞金テーブルに基づいて計算いたします。<br />
          </li>
          <li class="no-indent">
            ・<span class="txt-red"
              >各TURNで新たにモーター登録が必要です。</span
            >
          </li>
          <li class="no-indent">
            <span class="txt-red"
              >※2027年のモーター入替時期は現時点で未定です。</span
            >
            <div class="rule_box">
              <p class="rule_img">
                <img src="@/assets/images/rule/img_term.png" alt="" />
              </p>
            </div>
            <p class="rule_note">
              <span class="txt-red"
                >追加斡旋やモーターの故障による変更など、モーター抽選結果に無いモーターが何らかの理由で出走していても選択は出来ません。モグー加算もされません。</span
              >
            </p>
          </li>
        </ul>
      </div>
    </section>

    <!-- モーダル表示エリア -->
    <transition name="fade">
      <modalExample
        v-show="showModal"
        @close="closeModal"
        :initialData="modalData"
      />
    </transition>
  </section>
</template>

<script>
import modalExample from "@/components/modalExample.vue";
export default {
  name: "Rule",
  components: {
    modalExample,
  },
  data() {
    return {
      showModal: false,
      modalData: {},
    };
  },
  methods: {
    // モーダル関連のメソッド
    openModal(data = {}) {
      this.modalData = data;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.modalData = {};
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" src="@/assets/css/style_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_ranking.css" scoped></style>
<style lang="css" src="@/assets/css/style_select.css" scoped></style>

<style scoped>
/* クリック可能なテキストのスタイル */
.clickable-text {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-text:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.txt-blue {
  color: #007bff;
  font-weight: bold;
}

.txt-blue:hover {
  color: #0056b3;
}

/* モーターアイコンのホバー効果 */
.moter_icon.clickable-text:hover {
  transform: scale(1.05);
}
</style>
